var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGym = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M32.269 21.214c.68 0 1.23-.548 1.23-1.223 0-.676-.55-1.223-1.23-1.223M12.205 21.214h15.664M7.731 18.769c-.68 0-1.23.547-1.23 1.223 0 .675.55 1.223 1.23 1.223M27.81 18.769H12.145M31.3 15.896c-.505 0-.914.148-.949.618v-.947c0-.676-.552-.88-1.23-.88-.682 0-1.233.204-1.233.88v9.052c0 .677.552.88 1.232.88s1.231-.203 1.231-.88v-.945c.035.47.444.618.95.618.526 0 .955-.158.955-.682v-7.032c0-.525-.429-.682-.956-.682ZM10.894 14.688c-.68 0-1.231.202-1.231.878v.943c-.038-.468-.446-.614-.949-.614-.529 0-.956.157-.956.683v7.032c0 .524.427.68.956.68.503 0 .911-.146.949-.613v.942c0 .677.551.88 1.231.88s1.231-.203 1.231-.88v-9.053c0-.675-.551-.879-1.231-.879Z"
}))));
export default SvgGym;